$(window).on('load', function()
{
	$('.HEI-Resizable').resizable();
});